<template>
  <div class="teams-page">
    <h2 class="section-title">Registrované týmy</h2>
    
    <div class="row row-cols-1 row-cols-md-3 g-4 mt-4">
      <div v-for="team in teams" :key="team.id" class="col">
        <div class="card h-100 custom-card">
          <img v-if="team.logo" :src="`${apiUrl}${team.logo}`" class="card-img-top" :alt="team.name">
          <div class="card-body">
            <h5 class="card-title">{{ team.name }}</h5>
            <p class="card-text">
              Registrován: {{ formatDate(team.created_at) }}
            </p>
            <button class="btn btn-primary" @click="toggleRoster(team.id)">
              {{ expandedTeamId === team.id ? 'Skrýt soupisku' : 'Zobrazit soupisku' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Team Roster Modal -->
    <div v-if="expandedTeamId" class="modal-backdrop" @click="closeRoster">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ getTeamName(expandedTeamId) }} - Soupiska</h3>
          <button class="close-button" @click="closeRoster">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="col-jersey">#</th>
                  <th>Jméno</th>
                  <th>Příjmení</th>
                  <th>Pozice</th>
                  <th>Status</th>
                  <th>Aktivní/Schválený</th>
                  <th>Poznámka</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="player in teamPlayers" :key="player.id">
                  <td class="col-jersey">{{ player.jersey_number }}</td>
                  <td>{{ player.first_name }}</td>
                  <td>{{ player.last_name }}</td>
                  <td>{{ player.position }}</td>
                  <td>{{ player.is_registered ? 'R' : 'N' }}</td>
                  <td>
                    <span :class="player.isactive ? 'status-active' : 'status-inactive'">
                      {{ player.isactive ? 'Ano' : 'Ne' }}
                    </span>
                  </td>
                  <td>{{ player.note || '--' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TeamsList',
  data() {
    return {
      teams: [],
      expandedTeamId: null,
      teamPlayers: []
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    }
  },
  methods: {
    async loadTeams() {
      try {
        const response = await axios.get('/api/teams');
        this.teams = response.data;
      } catch (error) {
        console.error('Error loading teams:', error);
      }
    },
    async toggleRoster(teamId) {
      if (this.expandedTeamId === teamId) {
        this.closeRoster();
      } else {
        this.expandedTeamId = teamId;
        try {
          const response = await axios.get(`/api/teams/${teamId}/players?includeInactive=true`);
          this.teamPlayers = response.data;
        } catch (error) {
          console.error('Error loading team players:', error);
        }
      }
    },
    closeRoster() {
      this.expandedTeamId = null;
      this.teamPlayers = [];
    },
    getTeamName(teamId) {
      const team = this.teams.find(t => t.id === teamId);
      return team ? team.name : '';
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('cs-CZ');
    }
  },
  mounted() {
    this.loadTeams();
  }
}
</script>

<style scoped>
.teams-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
}

.section-title {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.card-img-top {
  height: 200px;
  object-fit: contain;
  padding: 1.5rem;
  background: #151d3a;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.custom-card {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  margin-bottom: 2rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.custom-card:hover {
  transform: translateY(-4px);
  border-color: rgba(31, 224, 255, 0.2);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4),
              0 0 0 1px rgba(31, 224, 255, 0.05);
}

.card-title {
  color: #e0e6f7;
  font-weight: 700;
  font-size: 1.2rem;
}

.card-text {
  color: #8892b0;
  font-size: 1rem;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 16, 35, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.1);
  border-radius: 1rem;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 16px 48px rgba(10, 16, 35, 0.7);
}

.modal-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(31, 224, 255, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  color: #e0e6f7;
  font-weight: 700;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  color: #8892b0;
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.2s;
}

.close-button:hover {
  color: #1fe0ff;
}

.modal-body {
  padding: 1.5rem;
}

.table {
  background: transparent;
  color: #e0e6f7;
  border-radius: 0.75rem;
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead th {
  background: rgba(31, 224, 255, 0.06);
  color: #1fe0ff;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border: none;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(31, 224, 255, 0.1);
}

.table td, .table th {
  border: none;
  padding: 0.7rem 1rem;
  vertical-align: middle;
}

.table td {
  border-bottom: 1px solid rgba(31, 224, 255, 0.04);
}

.table tbody tr {
  transition: background 0.2s ease;
}

.table tbody tr:hover {
  background: rgba(31, 224, 255, 0.03);
}

.btn-primary {
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023;
  font-weight: 700;
  border: none;
  border-radius: 0.5rem;
  padding: 0.55rem 1.5rem;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(31, 224, 255, 0.2);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.35);
  color: #0a1023;
}

.col-jersey {
  width: 40px;
  min-width: 40px;
  max-width: 60px;
  text-align: center;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.status-active {
  color: #34d399;
  font-weight: 700;
}

.status-inactive {
  color: #ff4d6a;
  font-weight: 700;
}
</style> 